// src/components/pages/Pessoa/helpers/pessoaDocUtils.js

export function onlyNumbers(str = '') {
    return String(str).replace(/[^0-9]/g, '');
}

export function getTipoByDocumento(doc = '') {
    const numero = onlyNumbers(doc);

    if (numero.length === 11) return 'Física';
    if (numero.length === 14) return 'Jurídica';
    return '';
}

export function isCpf(doc = '') {
    return onlyNumbers(doc).length === 11;
}

export function isCnpj(doc = '') {
    return onlyNumbers(doc).length === 14;
}
